import { HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Observable, Subscriber } from 'rxjs/Rx';
import { environment } from '../../../../../environments/environment';
import { HttpService } from './http.service';
import { catchError, map, retry } from 'rxjs/operators';
import { error } from 'console';
import { ifError } from 'assert';
import { throwError } from 'rxjs';

@Injectable()
export class ApplicationApi {
 
  private readonly apiController: string = 'superAdmin';
  private migrationurl1=environment.migrationurl;
  private verificationurl=environment.verificationurl;
  private convactionurl=environment.convourl;
  private pdcurl=environment.pdcurl;
  private atturl = environment.attestationurl;

  constructor(private api: HttpService,
    private http:HttpClient) { }

    get(url: string): Observable<any> {
      return new Observable((observer: Subscriber<any>) => {
          let objectUrl: string = null;
          this.http
              .get(url, {
                  responseType: 'blob'
              })
              .subscribe(m => {
                  objectUrl = URL.createObjectURL(m);
                  observer.next(objectUrl);
              });
  
          return () => {
              if (objectUrl) {
                  URL.revokeObjectURL(objectUrl);
                  objectUrl = null;
              }
          };
      });
  }

  private handleError(error){
    console.error(error);
  }

  getApplicationDetailsByUser(page,id,name,email,service,orderId,tracker,status,courseId){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getApplicationDetailsByUser?page=${page}&name=${name}&email=${email}&status=${status}&tracker=${tracker}&source_from=${service}&id=${id}&orderId=${orderId}&courseId=${courseId}`);
    }catch(error) {
      this.handleError("getApplicationDetailsByUser : "+JSON.stringify(error));
    }
  }
  getAutonomusApplicationDetailsByUser(page,id,name,email,service,status){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getAutonomusApplicationDetailsByUser?page=${page}&name=${name}&email=${email}&source_from=${service}&id=${id}&status=${status}`);
    }catch(error) {
      this.handleError("getAutonomusApplicationDetailsByUser : "+JSON.stringify(error));
    }
  }
  getApplicationDetailsByUser_Wes(page,id,name,email,service,tracker,status){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getApplicationDetailsByUser_wes?page=${page}&name=${name}&email=${email}&status=${status}&tracker=${tracker}&source_from=${service}&id=${id}`);
    }catch(error) {
      this.handleError("getApplicationDetailsByUser : "+JSON.stringify(error));
    }
  }

  downloadDocuments(documentFile):Observable<Blob>{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadDocuments?documentFile=`+documentFile, { headers: headers, responseType: 'blob'}).map(
    (res) => {
        return new Blob([res], { type: 'application/pdf' });
    });
  }
  getUsers(page,name,email){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/students?page=${page}&name=${name}&email=${email}`);
    }catch(error) {
      this.handleError("getUsers : "+JSON.stringify(error));
    }
  }
  getallstudentfeedback(){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/student_feeback`);
    }catch(error) {
      this.handleError("getallstudentfeedback : "+JSON.stringify(error));
    }
  }
  
  superview(category,userId){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/superview?userId=${userId}&category=${category}`);
    }catch(error) {
      this.handleError("getApplicationDetailsByUser : "+JSON.stringify(error));
    }
  }

  lockUnlockEdu(app_id,lock){
    try{
      return this.http.post(`${this.migrationurl1}/admin/adminDashboard/lockUnlockEdu`,{"app_id":app_id,"lock":lock});
    }catch(error){
      this.handleError(" lockUnlockEdu : "+JSON.stringify(error))
    }
  }

  saveNotes(id,notes){
    try{
      return this.http.post(`${this.migrationurl1}/admin/saveNotes`,{id : id, notes : notes});
    }catch(error) {
      this.handleError("saveNotes : "+JSON.stringify(error));
    }
  }
   deleteDocumentbyAdmin(user_id,id,type,source,filename){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/deleteDocument_Admin`,{user_id : user_id,id : id,type : type,source : source, filename : filename});
    }catch(error) {
      this.handleError("deleteDocument_Admin : "+JSON.stringify(error));
    }
  }

 

  
  checkPrn(source, prnNumber){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/checkPrn?source=${source}&prnNumber=${prnNumber}`)
    }catch(error){
      this.handleError("checkTransStatus: "+JSON.stringify(error));
    }
  }
  termWiseData(source, prnNumber,TermName, resultStatus){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/termWiseData?source=${source}&prnNumber=${prnNumber}&TermName=${TermName}&resultStatus=${resultStatus}`)
    }catch(error){
      this.handleError("termWiseData: "+JSON.stringify(error));
    }
  }


  saveOutwardMultiple(app_id,syoutward,marksheetoutward,transcriptoutward,degreeoutward,thesisoutward,bachinstructionaloutward,mastinstructionaloutward,phdinstructionaloutward,source,user_id,migrationoutward, tcoutward , pdcoutward, convocationoutward){
   
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveOutwardMultiple`,{app_id : app_id,syoutward: syoutward,marksheetoutward : marksheetoutward,transcriptoutward : transcriptoutward , degreeoutward : degreeoutward ,thesisoutward : thesisoutward , bachinstructionaloutward  : bachinstructionaloutward ,mastinstructionaloutward :mastinstructionaloutward ,phdinstructionaloutward : phdinstructionaloutward,source:source,user_id : user_id ,migrationoutward :migrationoutward ,  tcoutward : tcoutward,pdcoutward :pdcoutward,convocationoutward :convocationoutward});
    }catch(error) {
      this.handleError("saveOutwardMultiple : "+JSON.stringify(error));
    }
  }
  getOutwardData(user_id,app_id,source){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getOutwardData?user_id=${user_id}&app_id=${app_id}&source=${source}`);
  }
  
  feedBack(satisfy, recommend, staff, experience, exp_prob, suggestion,user_id){
    return this.http.post(`${environment.apiUrl}/feedBack`,{"satisfy":satisfy, "recommend":recommend, "staff":staff, "experience":experience, "exp_prob":exp_prob, "suggestion":suggestion, "user_id":user_id});
}
  checkTransStatus(user_id) {
    try{
      return this.http.get(`${this.migrationurl1}/admin/adminDashboard/getAppTransStatus?user_id=${user_id}`)
    }catch(error){
      this.handleError("checkTransStatus: "+JSON.stringify(error));
    }
  }

  verification(app_id,user_id,type,checked){
    try{
      return this.http.post(`${this.migrationurl1}/admin/adminDashboard/verification`,{"user_id":user_id,"app_id":app_id,"type":type,"checked":checked});;
    }catch(error){
      this.handleError("verification : "+JSON.stringify(error));
    }
  }

  setTrackerStatus(userId,id,type,source_from,outward){
   
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/setTrackerStatus`,{user_id : userId,id : id,type : type,source_from:source_from,outward:outward});
    }catch(error) {
      this.handleError("setTrackerStatus : "+JSON.stringify(error));
    }
  }

  setApplictaionFormDate(event,user_id,app_id,value){
   
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/setApplictaionFormDate`,{event: event ,user_id: user_id ,id:app_id , value : value});
    }catch(error) {
      this.handleError("setApplictaionFormDate : "+JSON.stringify(error));
    }
  }
  saveMigrationEducation(data , source, year ){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveMigrationEducation`,{data :data , source  : source, year  : year});
    }catch(error) {
      this.handleError("saveMigrationEducation : "+JSON.stringify(error));
    }
  }


  savePdcEducation(data){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/savePdcEducation`,{data :data});
    }catch(error) {
      this.handleError("saveMigrationEducation : "+JSON.stringify(error));
    }
  }
  // Degree Certificate (soldegree) education edit
  getDegreeExamCourses(){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getDegreeExamCourses`);
  }

  saveDegreeEducation(data){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/saveDegreeEducation`,{data :data});
  }

  saveDuplicateDegreeEducation(data){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveDuplicateDegreeEducation`,{data :data});
    }catch(error) {
      this.handleError("saveMigrationEducation : "+JSON.stringify(error));
    }
  }

  saveDuplicateMarksheetEducation(data){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveDuplicateMarksheetEducation`,{data :data});
    }catch(error) {
      this.handleError("saveMigrationEducation : "+JSON.stringify(error));
    }
  }

  deleteEducation(id,app_id, user_id,type ){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/deleteEducation`,{id :id ,app_id : app_id, user_id : user_id,type : type});
    }catch(error) {
      this.handleError("deleteEducation : "+JSON.stringify(error));
    }
  }
  deleteDocumentsAdmin(id,app_id, user_id,type ){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/deleteDocumentsAdmin`,{id :id ,app_id : app_id, user_id : user_id,type : type});
    }catch(error) {
      this.handleError("deleteDocumentsAdmin : "+JSON.stringify(error));
    }
  }


  verifyparticularDocuments(app_id,user_id,checked,type,source,doc_id,outward){
   
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/verifyparticularDocuments`,{app_id : app_id,user_id : user_id,checked:checked,type:type , source : source ,doc_id : doc_id, outward: outward});
    }catch(error) {
      this.handleError("verifyparticularDocuments : "+JSON.stringify(error));
    }
  }

  setDocumentAs(checked,doc_id,setas){
   
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/setDocumentAs`,{checked:checked,doc_id : doc_id,setas : setas});
    }catch(error) {
      this.handleError("setDocumentAs : "+JSON.stringify(error));
    }
  }

  saveOutward(app_id,outward,source,user_id,type,letterFormat){
   
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveOutward`,{app_id : app_id,outward : outward,source:source,user_id : user_id,type: type,letterFormat : letterFormat});
    }catch(error) {
      this.handleError("saveOutward : "+JSON.stringify(error));
    }
  }

  checksignedpdf(id , userId,source_from){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/checksignedpdf?id=${id}&userId=${userId}&source_from=${source_from}`);
  }

  sendemail(id,user_id,source_from,type){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/sendEmail`,{id:id,source_from:source_from,type : type , user_id  : user_id});
  }

  superactivitytracker(page,date,data,email,service){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/superactivitytracker?page=${page}&date=${date}&data=${data}&email=${email}&service=${service}`);
    }catch(error) {
      this.handleError("superactivitytracker : "+JSON.stringify(error));
    }
  }

  getTcResult(app_id){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getTcResult?app_id=` + app_id);
  }

  printSuperAdmin(source_from: any, app_id:any, user_id :any,dataValues :any, tcRemark?: any) {
    // if(source_from == "solverification"){
    //   return this.http.post(`${environment.apiUrl}/${this.apiController}/printSuperAdmin`,{"source_from":source_from,"app_id":app_id,"user_id":user_id,"dataValues":dataValues})
    //   .pipe(

    //     retry(2),
    //     catchError((this.httpError))
    //   )
    // }else{
        try{
        return this.http.post(`${environment.apiUrl}/${this.apiController}/printSuperAdmin`,{"source_from":source_from,"app_id":app_id,"user_id":user_id,"dataValues":dataValues,"tcRemark":tcRemark})
      }catch(error) {

        this.handleError("superactivitytracker : "+JSON.stringify(error));
      }
    // }   
  }

  httpError(error : any) {
    
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  getSuperMenuRole(userID){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/getSuperMenuRole?userID=`+userID);
    }catch(error){
      this.handleError(" getSuperMenuRole : "+JSON.stringify(error));
    }
  }

  addupdateRole(roles,superroles,source_array,activity,course,college,user_id){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/role_management/setUpdateRole`,{"roles":roles,"superroles":superroles,"source_array":source_array,"activity":activity , "course" : course, "college" : college,"user_id":user_id});
    }catch(error) {
        this.handleError("addupdateRole : "+JSON.stringify(error));
      }
  }

  getallsubadmin(name,email){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/main?name=`+name+`&email=`+email);
    }catch(error) {
      this.handleError("getallsubadmin : "+JSON.stringify(error));
    }
  }

  changeSubAdminStatus(userId){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/role_management/changeSubAdminStatus`,{"userId" : userId});
    }catch(error) {
      this.handleError("changeSubAdminStatus : "+JSON.stringify(error));
    }
  }

  getRolesData(userId){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/getRolesData?userId=`+userId);
    }catch(error) {
        this.handleError("getRolesData : "+JSON.stringify(error));
      }
  }

  getCoursesAdmin(){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/getCoursesAdmin`);
    }catch(error) {
        this.handleError("getCoursesAdmin : "+JSON.stringify(error));
      }
  }

  getCollegesAdmin(){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/getCollegesAdmin`);
    }catch(error) {
        this.handleError("getCollegesAdmin : "+JSON.stringify(error));
      }
  }

  addUpdatesubAdmin(userId, subAdminData){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/role_management/addUpdatesubAdmin`,{"userId" : userId, "subAdminData" : subAdminData});
    }catch(error) {
      this.handleError("addUpdatesubAdmin : "+JSON.stringify(error));
    }
  }

  getSubAdminData(userId){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/getSubAdminData?userId=`+userId);
    }catch(error) {
      this.handleError("getSubAdminData : "+JSON.stringify(error));
    }
  }

  async getAllTranscriptData(userId,app_id){
    try{
      return await this.http.get(`${environment.apiUrl}/${this.apiController}/transcript_lock?userId=`+userId+"&app_id="+app_id).toPromise();
    }catch(error) {
      this.handleError("Error in getAllTranscriptData : "+error); 
    }
  }
  
  getAllTranscriptDataAppWisesuper(userId,category){
    try{
      return  this.http.get(`${environment.apiUrl}/${this.apiController}/appWiseDocssuper?userId=`+userId+"&category="+category)
    }catch(error) {
      this.handleError("Error in getAllTranscriptDataAppWise : "+error);  
    }
  }

  convocationDecision(app_id,user_id,event,type,name){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/convocationDecision`,{app_id : app_id, user_id : user_id, eventChecked : event,type : type, name});
    }catch(error) {
      this.handleError("convocationDecision : "+JSON.stringify(error));
    }
  }

  updateErrataTranscript(errataTranscript,errataMarksheet){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/updateErrataTranscript`,{"errataTranscript":errataTranscript,"errataMarksheet":errataMarksheet});
    }catch(error) {
      this.handleError("login from api : "+error);
    }
  }

  getAdminInstructionalEducation(userId){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getAdminInstructionalDetails?userId=`+userId);
    }catch(error) {
      this.handleError("getAdminInstructionalEducation: "+JSON.stringify(error)); 
    }
  }
  
  getCollegeWiseApplication(page,service){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/collegeWiseApplicationCount?page=${page}&source_from=${service}`)
    }catch(error) {
      this.handleError("getEmailActivityTracker : "+JSON.stringify(error)); 
    }
  }
  
  printDocuments(source_from,app_id,user_id){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/printDocuments?source_from=${source_from}&app_id=${app_id}&user_id=${user_id}`)
    }catch(error) {
      this.handleError("printDocuments : "+JSON.stringify(error));
    }
  }

  getDeliveryTypeModeWiseAppCount(){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/deliveryTypeModeWiseAppCount`)
    }catch(error) {
      this.handleError("getDeliveryTypeModeWiseAppCount : "+JSON.stringify(error));
    }
  }

  getStudentDetails(page,studentName,email){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getStudentDetails?page=${page}&studentName=${studentName}&email=${email}`)
    }catch(error) {
      this.handleError("getStudentDetails : "+JSON.stringify(error));
    }
  }

  getPrintAddress(appl_id,user_id,section,source_from,addressid) {
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/printAddress`,{"user_id":user_id, "appl_id": appl_id, "section":section, "source_from" : source_from, "addressid" : addressid});
    }catch(error) {
        this.handleError("printAddress : "+JSON.stringify(error));
    }
  }

  transcriptRequiredMail(app_id,user_id,event,type){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/transcriptRequiredMail`,{app_id : app_id, user_id : user_id, eventChecked : event, type : type});
    }catch(error) {
        this.handleError("transcriptRequiredMail : "+JSON.stringify(error));
    }
  }

  marksheetsRequired(app_id,user_id,event,type){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/marksheetsRequired`,{app_id : app_id, user_id : user_id, eventChecked : event,type : type});
    }catch(error) {
        this.handleError("marksheetsRequired : "+JSON.stringify(error));
    }
  }

  sendmessage(msg_from_admin_data){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/trans_sendmessage`,{"msg":msg_from_admin_data});
    }catch(error) {
      this.handleError("ERROR sendmessage : "+error);
    }
  }

  setApplicationErrata(event,id,user_id,type,app_id,message,source,errataType,whicherrata){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/setApplicationErrata`,{event : event, id: id, user_id : user_id, type : type, app_id : app_id, message : message, source:source,errataType,whicherrata: whicherrata});
  }

  setErratacon(value,userId,notes,doc_id){
    return this.http.post(`${this.convactionurl}/setErrata`,{'value': value ,'userId'  : userId ,'notes' : notes , 'doc_id': doc_id});
   }

  setErrata(app_id,notes,docid,type){
    return  this.http.post(`${this.pdcurl}/setErrata`,{'app_id'  : app_id ,'notes' : notes , 'docid': docid,'type':type});
  }

  updateNoteAndApplication(app_id,user_id,event,type,note){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/updateNoteAndApplication`,{app_id : app_id, user_id : user_id, eventChecked : event,type : type,note : note});
    }catch(error) {
        this.handleError("updateNoteAndApplication : "+JSON.stringify(error));
    }
  }

  sendmessagemigration(msg_from_admin_data){
    try{
      return this.http.post(`${this.migrationurl1}/admin/adminDashboard/trans_sendmessage`,{"msg":msg_from_admin_data});
    }catch(error) {
      this.handleError("ERROR sendmessage : "+error);
    }
  }

  getCollegeWiseApplicationsCount(page){
    try{
      return  this.http.get(`${environment.apiUrl}/${this.apiController}/getCollegeWiseApplicationsCount?page=${page}`);
    }catch(error) {
      this.handleError("Error in getCollegeWiseApplicationsCount : "+error);
    }
  }

  pieCharts(){
    try{
      return  this.http.get(`${environment.apiUrl}/${this.apiController}/pieCharts`);
    }catch(error) {
      this.handleError("Error in pieCharts : "+error);
    }
  }

  rejectApplication(userId,id,source_from){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/rejectApplication`,{user_id : userId,id : id,source_from:source_from});
    }catch(error) {
      this.handleError("rejectApplication : "+JSON.stringify(error));
    }
  }

  removeFromReject(userId,id,source_from){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/removeFromReject`,{user_id : userId,id : id,source_from:source_from});
    }catch(error) {
      this.handleError("rejectApplication : "+JSON.stringify(error));
    }
  }

  getMenuRole(userID){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/getSuperMenuRole?userID=`+userID);
    }catch(error){
      this.handleError(" getMenuRole : "+JSON.stringify(error));
    }
  }

  regeneratePdf(appl_id,user_id,reg_reason,source_from) {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/regeneratePdf?user_id=${user_id}&app_id=${appl_id}&reg_reason=${reg_reason}&source_from=${source_from}`);
  }
  outward(user_id,app_id,source,outward){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/outward`,{user_id : user_id,app_id : app_id,source:source,outward:outward});
    }catch(error) {
      this.handleError("inward : "+JSON.stringify(error));
    }
  }


  downloadExcel(tracker,status,tab,startDate,endDate,service){
    

    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadExcel?tracker=${tracker}&status=${status}&tab=${tab}&startDate=${startDate}&endDate=${endDate}&service=${service}`);
    }catch(error) {
      this.handleError("downloadExcel : "+JSON.stringify(error));
    }
  }

  downloadExcel_degree(tracker,status,tab,startDate,endDate,service){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadExcel_degree?tracker=${tracker}&status=${status}&tab=${tab}&startDate=${startDate}&endDate=${endDate}&service=${service}`);
    }catch(error) {
      this.handleError("downloadExcel_degree : "+JSON.stringify(error));
    }
  }

  downloadExcel_marksheet(tracker,status,tab,startDate,endDate,service){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadExcel_marksheet?tracker=${tracker}&status=${status}&tab=${tab}&startDate=${startDate}&endDate=${endDate}&service=${service}`);
    }catch(error) {
      this.handleError("downloadExcel_marksheet : "+JSON.stringify(error));
    }
  }

  downloadExcelFaq(){
    try{
        return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadExcelFaq`);
    }catch(error) {
        this.handleError("downloadExcelFaq : "+JSON.stringify(error));
    }
  }


  downloadExcel_wes(tracker,status,tab,startDate,endDate,service){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadExcel_wes?tracker=${tracker}&status=${status}&tab=${tab}&startDate=${startDate}&endDate=${endDate}&service=${service}`);
    }catch(error) {
      this.handleError("downloadExcel_wes : "+JSON.stringify(error));
    }
  }
  getFileData(page,date) {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getFileData?page=${page}&date=${date}`);
  }

  downloadFileExcel(date) {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadFileExcel?date=${date}`);
  }

  downloadFiles(documentFile):Observable<Blob>{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadFiles?documentFile=`+documentFile, { headers: headers, responseType: 'blob'}).map(
    (res) => {
        return new Blob([res], { type: 'application/pdf' });
    });
  }

  
  // downloadPdf(documentFile){
  //   let headers = new HttpHeaders();
  //   headers.append('Content-Type', 'application/json');
  //   return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadPdf?documentFile=`+documentFile, { headers: headers, responseType: 'blob'}).map(
  //   (res) => {
  //       return new Blob([res], { type: 'application/pdf' });
  //   });
  // }

  downloadPdf(service,tracker, startDate, endDate){
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadPdf?service=${service}&tracker=${tracker}&startDate=${startDate}&endDate=${endDate}`, { headers: headers, responseType: 'blob'}).map(
    (res) => {
        return new Blob([res], { type: 'application/pdf' });
    });
  }

  getPaymentDetails(tab_type){
   return this.http.get(`${environment.apiUrl}/${this.apiController}/getPaymentDetails?tab_type=`+tab_type);
  }

  setResolve(id,email,value){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/setResolve`,{ "id" : id,"email" : email,"value":value});
  }

  getallpedingpayment(page,date,email,value){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getallpedingpayment?page=${page}&date=${date}&email=${email}&value=${value}`);
  }

  getPaymentdeatils(value){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/application/getPaymentdeatils?value=${value}`);
  }

  
  getAll_Paydetails(page,id,name,email,order_id,bank_ref_no){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getAll_Paydetails?page=${page}&id=${id}&name=${name}&email=${email}&order_id=${order_id}&bank_ref_no=${bank_ref_no}`);
  }
  downloadExcel_date(startDate, endDate) {

    try {
      return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadExcel_date?startDate=` + startDate + '&endDate=' + endDate)
    } catch (error) {

    }}
 
  getStudentApplicationDetails(userId,services){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getStudentApplicationDetails?userId=${userId}&services=${services}`);
  }
  savePersonalForm(personalDetails,userId,id){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/updateStudentDetails`,{userId:userId, personalDetails:personalDetails,id:id});
  }
/* To save pickup data with name and date */
  pickupdate(app_id,user_id,trackingId,name,source_from,type){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/pickupdate`,{user_id : user_id,app_id : app_id,name:name,source_from:source_from,trackingId:trackingId,type : type});
    }catch(error) {
      this.handleError("pickupdate : "+JSON.stringify(error));
    }
  }
  pickupmail(app_id,user_id,source_from,date,time){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/pickupmail`,{user_id : user_id,app_id : app_id,source_from:source_from,date : date,time:  time});
    }catch(error) {
      this.handleError("pickupdate : "+JSON.stringify(error));
    }
  }
  sentoEdulab(user_id,app_id,source_from,name){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/sentoEdulab`,{user_id : user_id,app_id : app_id,source_from:source_from,name : name});
    }catch(error) {
      this.handleError("sentoEdulab : "+JSON.stringify(error));
    }
  }

  getFileDetails(app_id,user_id){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getFileDetails?app_id=${app_id}&user_id=${user_id}`)
}

  setVerifyforPrint(event,app_id,userId){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/setVerifyforPrint`,{event : event , app_id :  app_id , userId: userId});
    }catch(error) {
      this.handleError("setVerifyforPrint : "+JSON.stringify(error));
    }
  }

  getapplication(id){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getapplication?id=`+id);
    }catch(error) {
      this.handleError("setTrackerStatus : "+JSON.stringify(error));
    }
  }

  setErrataNotes(app_id,notes,docid,type){
    return  this.http.post(`${environment.apiUrl}/${this.apiController}/setErrata`,{'app_id'  : app_id ,'notes' : notes , 'docid': docid,'type':type});
  }
  downloadDocs(app_id,userId,type,source_from){
    if(type == 'ApplicationForm'){
      return this.http.get(`${environment.apiUrl}/${this.apiController}/generatepdfform?app_id=${app_id}&user_id=${userId}&source_from=${source_from}`);
    }else if(type=='mergedDocuments'){
      return this.http.get(`${environment.apiUrl}/${this.apiController}/mergeDocuments?app_id=${app_id}&user_id=${userId}&source_from=${source_from}`);
    }
  }

  getAdminDetails(){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getAdminDetails`);
  }
  saveInstructional(id,value){
   
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveInstructional`,{id : id ,value : value});
    }catch(error) {
      this.handleError("saveInstructional : "+JSON.stringify(error));
    }
  }
  deleteDocument(id,userId,app_id){    
    return this.http.delete(`${environment.apiUrl}/${this.apiController}/deleteDocument?id=${id}&userId=${userId},&app_id=${app_id}`);
  }
  getParticularInstructionalDetails(id){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getParticularInstructionalDetails?id=${id}`);
  }
  viewFileStatus(userId,appId){
    try{
      return this.http.get( `${environment.apiUrl}/${this.apiController}/viewFileStatus?userid=${userId}&app_id=${appId}`);
    
  }catch(error){
    this.handleError("getWesFiles : "+JSON.stringify(error));
  }
  }

  colornagnge(value,app_id,source){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/colornagnge`,{value : value,app_id : app_id,source:source});
    }catch(error) {
      this.handleError("inward : "+JSON.stringify(error));
    }
  }
  
  getCollegeData(){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/collegeManagement/getCollegeData`);
  }
  getCousreData(){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getCousreData`);
  }

  updateCollegeStatus(status, college_id, college_name){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/collegeManagement/updateCollegeStatus?college_id=${college_id}&college_status=${status}&college_name=${college_name}`)
    }catch(error) {
      this.handleError("updateCollegeStatus : "+JSON.stringify(error));
    }
  }
  removeCollege(college){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/collegeManagement/removeCollege`,{'college':college})
    }catch(error) {
      this.handleError("addOrUpdateCollegeData : "+JSON.stringify(error));
    }
  }

  
  removeCourse(course){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/collegeManagement/removeCourse`,{'course':course})
    }catch(error) {
      this.handleError("addOrUpdateCollegeData : "+JSON.stringify(error));
    }
  }
  saveCourseinCollege(course : any , collegeId  : any){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/collegeManagement/saveCourseinCollege`,{'course':course,"collegeId":  collegeId})
    }catch(error) {
      this.handleError("saveCourseinCollege : "+JSON.stringify(error));
    }
  }

  AddCourseName(course_name,degree_type,duration,addEdit,id,faculty,college_short_form,specialization){
    try{
    return this.http.post(`${environment.apiUrl}/${this.apiController}/collegeManagement/addcourse`,{course_name:course_name,degree_type:degree_type,duration:duration,addEdit:addEdit,id:id,faculty: faculty,college_short_form:college_short_form,specialization:specialization})
  }catch(error) {
    this.handleError("addOrUpdateCollegeData : "+JSON.stringify(error));
  }
  }

  sendEmailToCollege(collegeId,user_id){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/sendEmailToCollege?collegeId=${collegeId}&user_id=${user_id}`);
    }catch(error) {
      this.handleError("deleteNotification : "+error);
    }
  }

  addOrUpdateCollegeData(data){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/collegeManagement/addOrUpdateCollegeData`,{data:data})
    }catch(error) {
      this.handleError("addOrUpdateCollegeData : "+JSON.stringify(error));
    }
  }

  addOrUpdateCourseData(data){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/collegeManagement/addOrUpdateCourseData?courseData=${data}`)
    }catch(error) {
      this.handleError("addOrUpdateCourseData : "+JSON.stringify(error));
    }
  }

  admin_pass_reset(type,user_mail,id,userId){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/adminResetPassword`,{type: type, data: user_mail,id:id,userId:userId});
    }catch (error) {
      this.handleError("adminResetPassword: "+JSON.stringify(error));
    }
  }
  saveapplication(userid,app_id,source,value){
      try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveapplication`,{userid : userid,app_id : app_id,source:source,value:value});
    }catch(error) {
      this.handleError("ERROR sendmessage : "+error);
    }
  }
  getCourses(){
    try{
  return  this.http.get(`${environment.apiUrl}/${this.apiController}/getCourses`);

    }catch(error){
      this.handleError("getCourses: "+JSON.stringify(error));
    }
  }
  getColleges(){
    try{

      return  this.http.get(`${environment.apiUrl}/${this.apiController}/getColleges`);

    }catch(error){
      this.handleError("getColleges: "+JSON.stringify(error));
    }
  }

  getCourseDetails(course,pattern){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/courseDetails?course=${course}&pattern=${pattern}`)
  }


  saveEduDetails(data,source){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/saveEduDetails`,{errataDetails : data,source_from : source});
  }

  saveInsDetails(data,source){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/saveInsDetails`,{errataDetails : data,source_from : source});
  }

  saveAddDetails(documentDetailsData,source,type,user_id,app_id){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/saveAddDetails`,{documentDetailsData : documentDetailsData,source_from : source,type : type,user_id:user_id,app_id:app_id});
  }
    saveinstitutiondetails(id,value,informadmin,app_id,Adminemail,user_id){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveinstitutiondetails`,{id : id ,value : value,informadmin: informadmin, app_id : app_id,Adminemail:Adminemail,user_id:user_id});
    }catch(error) {
      this.handleError("saveinstitutiondetails : "+JSON.stringify(error));
    }
  }
  RemoveCurrentYear(user_id,id,value){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/RemoveCurrentYear`,{user_id : user_id,app_id : id,value : value});
    }catch(error) {
      this.handleError("RemoveCurrentYear : "+JSON.stringify(error));
    }
  }

  getParticularInstitutionDetails(id){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getParticularInstitutionDetails?id=${id}`);
  }
  download(source_from,startDate,endDate){  
    return this.http.get(`${environment.apiUrl}/${this.apiController}/download?source_from=${source_from}&startDate=${startDate}&endDate=${endDate}`);
  }
  download_notesNull(){  
    return this.http.get(`${environment.apiUrl}/${this.apiController}/download_notesNull`);
  }
  getusermarklist(type,app_id,user_id){  
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getusermarklist?type=${type}&app_id=${app_id}&user_id=${user_id}`);

  }

  getApplicationDetailsByUser_WesRangeWise(page,id,name,email,service,tracker,status,startDate,endDate){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getApplicationDetailsByUser_WesRangeWise?page=${page}&name=${name}&email=${email}&status=${status}&tracker=${tracker}&source_from=${service}&id=${id}&startDate=${startDate}&endDate=${endDate}`);
    }catch(error) {
      this.handleError("getApplicationDetailsByUser : "+JSON.stringify(error));
    }
  }
  
  resetDoc(user_id){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/resetDoc?user_id=${user_id}`);
    }catch(error){
      this.handleError("resetDoc : " + JSON.stringify(error));
    }
  }

  updateAttestedFor(userid,app_id,source,value){
    try{
    return this.http.post(`${environment.apiUrl}/${this.apiController}/updateAttestedFor`,{userid : userid,app_id : app_id,source:source,value:value});
  }catch(error) {
    this.handleError("ERROR sendmessage : "+error);
  }
}
  changeDeliveryMode(userid,app_id,value,noofcopies,address){
    try{
    return this.http.post(`${environment.apiUrl}/${this.apiController}/changeDeliveryMode`,{userid : userid,app_id : app_id,value:value,noofcopies : noofcopies,address : address});
  }catch(error) {
    this.handleError("ERROR sendmessage : "+error);
  }
}

splitLookUp(orderId,refNum,service,edulabShare,universityShare){
  try{
     return this.http.post(`${environment.apiUrl}/${this.apiController}/splitLookUp`,{orderId : orderId,refNum : refNum,service : service,edulabShare : edulabShare,universityShare : universityShare});
   }catch(error) {
     this.handleError("orderLookUp : "+JSON.stringify(error));
   } 
 }

sendmailtostudent(userid,email){
  try{
  return this.http.post(`${environment.apiUrl}/${this.apiController}/sendmailtostudent`,{userid : userid,email : email,});
}catch(error) {
  this.handleError("sendmailtostudent : "+error);
}
}
/* To get Application details form view the data */
getApplicationDetails(id){ 
  return this.http.get(`${environment.apiUrl}/${this.apiController}/getApplicationDetails?app_id=${id}`);
 }

/* To give the access for particular email */
 addupdaterights(dtChecked,deChecked,reChecked,udChecked, drChecked,gmChecked,pmChecked,rmChecked,dxChecked,user_id){
  try{
    return this.http.post(`${environment.apiUrl}/${this.apiController}/role_management/saverights`,{"userId" : user_id, "dtChecked" : dtChecked , "deChecked" : deChecked ,"reChecked" : reChecked ,"udChecked" : udChecked ,"drChecked" : drChecked,"gmChecked":gmChecked,"pmChecked":pmChecked,"rmChecked":rmChecked ,"dxChecked" : dxChecked});
  }catch(error) {
    this.handleError("addUpdatesubAdmin : "+JSON.stringify(error));
  }
}

/* To get the access of  particular email */
getRoles_edulab(userId){  
  try{
    return this.http.get(`${environment.apiUrl}/${this.apiController}/role_management/getRolesedulab?userId=`+userId);
  }catch(error) {
      this.handleError("getRolesedulab : "+JSON.stringify(error));
    }
}

/* To get the Dubai Embassy Details  */
getEmbassyDetails(id){
  return this.http.get(`${environment.apiUrl}/${this.apiController}/getEmbassyDetails?id=${id}`);
}

/* To Edit the Dubai Embassy Details  */
SavedubaiembassyDetails(id,value,adminemail,app_id,userId){
  try{
    return this.http.post(`${environment.apiUrl}/${this.apiController}/savedubaiembassysdetails`,{id : id ,value : value,adminemail:adminemail,app_id:app_id,userId:userId});
  }catch(error) {
    this.handleError("savedubaiembassysdetails : "+JSON.stringify(error));
  }
}

getUserInfo(app_id,user_id,source){
  try{
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getUserInfo?user_id=${user_id}&source=${source}&app_id=${app_id}`);
  }catch(error) {
    this.handleError("getUserInfo : "+JSON.stringify(error));

  }
}
generatemissingdoc(app_id,user_id,source,doc_id){
  try{
    return this.http.post(`${environment.apiUrl}/${this.apiController}/generatemissingdoc`,{app_id : app_id,user_id : user_id,source:source,doc_id:doc_id})
  }catch(error)
{
  this.handleError("getUserInfo : "+JSON.stringify(error));


}
}
  orderLookUp(orderId,refNum,service){
   try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/orderLookUp`,{orderId : orderId,refNum : refNum,service : service});
    }catch(error) {
      this.handleError("orderLookUp : "+JSON.stringify(error));
    } 
  }

  getCourseForSupportingDocuments(app_id,user_id){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getCourseForSupportingDocuments?app_id=${app_id}&user_id=${user_id}`);
  }

  addInsDetails(errataDetails,app_id,user_id){
    try{
       return this.http.post(`${environment.apiUrl}/${this.apiController}/addInsDetails`,{errataDetails : errataDetails,app_id : app_id,user_id : user_id});
     }catch(error) {
       this.handleError("addInsDetails : "+JSON.stringify(error));
     } 
   }
   
   /* To Generate missing documents for attestation  */
  generateMissingDocs(userId,appId, source) {    
    try {
      return this.http.post(`${environment.apiUrl}/${this.apiController}/generateMissingDocs`, {source: source, userId: userId,appId: appId  })
    } catch (error) {
      this.handleError("getUserInfo : " + JSON.stringify(error));
    }

  }
 /* To Resend Email missing documents for attestation  */
  resendEmail(id,source_from,type){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/resendEmail`,{id:id,source_from:source_from,type : type});
  }

  getAgentDetails(page,agentName,email){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getAgentDetails?page=${page}&name=${agentName}&email=${email}`);
  }

  resetPasswordOtp(email,type){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/resetPasswordOtp`,{email:email,type : type});
  }

  excelDownload(user_id,app_id){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadExcel_verifiedDetails?user_id=${user_id}&app_id=${app_id}`);
    }catch(error) {
      this.handleError("excelDownload : "+JSON.stringify(error));
    }
  }

  Program_List() {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/Program_List`)
  }

  getEduLevelCourses(level) {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getEduLevelCouses?level=` + level)
  }

  getInputFieldsData(applicantId,year) {
    try {
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getInputFieldsData?applicantId=${applicantId}&year=${year}`);
    } catch (error) {
      this.handleError("getInputFieldsData : " + JSON.stringify(error));
    }
  }

  setEducationalValues(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/${this.apiController}/set_Educational_Values`, { 'item': item })
  }

  getapplicantdata(id) {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getapplicantdata?id=` + id)
  }

  updatesecondformData(item: any, id): Observable<any> {
    return this.http.post(`${environment.apiUrl}/${this.apiController}/updatesecondformData`, { 'item': item, 'appli_id': id })
  }

  // downloadTotalExcel(source){  
  //   try{
  //     return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadTotalExcel?source=`+source);
  //   }catch(error) {
  //       this.handleError("downloadTotalExcel : "+JSON.stringify(error));
  //     }
  // }

  downloadTotalExcel(source: string): Observable<Blob> {
    const url = `${environment.apiUrl}/${this.apiController}/downloadTotalExcel?source=${source}`;
    
    // Ensure that 'blob' is specified as the responseType
    return this.http.get(url, { responseType: 'blob' });
  }

  generateTranscriptFormat(app_id){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/generateTranscriptFormat`,{ "app_id" : app_id });
  }

  downloadTotalTabExcel(): Observable<Blob> {
    const url = `${environment.apiUrl}/${this.apiController}/downloadTotalTabExcel`;
    
    // Ensure that 'blob' is specified as the responseType
    return this.http.get(url, { responseType: 'blob' });
  }

  getCourseCollegeData(id) {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/getCourseCollegeData?id=` + id)
  }
  
  removeCollegeCourse(college_id,course_id){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/removeCollegeCourse`,{college_id:college_id,course_id:course_id,});
  }

  downloadTermwiseExcel(fetchDataValues,appData): Observable<Blob> {
    const url = `${environment.apiUrl}/${this.apiController}/termWiseExcelDownload`;
    
    // Ensure that 'blob' is specified as the responseType
    return this.http.post(url, { fetchDataValues, appData }, { responseType: 'blob' });
  }
  
  downloadExcelPendingDegree(queryStartDate, queryEndDate, service): Observable<Blob> {
    const url = `${environment.apiUrl}/${this.apiController}/downloadExcelPendingDegree`;
    
    // Ensure that 'blob' is specified as the responseType
    return this.http.post(url, { queryStartDate, queryEndDate, service }, { responseType: 'blob' });
  }

  getPdcDegree(page, prn, tab) {
    try {
      return this.http.get(`${environment.apiUrl}/${this.apiController}/pdcDegree?page=${page}&prn=${prn}&tab=${tab}`);
    } catch (error) {
      this.handleError("getPdcDegree : " + JSON.stringify(error));
    }
  }
  addSinglePdc(data: any,tab:string): Observable<any> {
    try {
      return this.http.post(`${environment.apiUrl}/${this.apiController}/autoGeneratedAppPdcSingle`, { data: data, source: tab });
    } catch (error) {
      this.handleError("addSinglePdc : " + JSON.stringify(error));
    }
  }
  addSingleDegree(data: any,tab:string): Observable<any> {
    try {
      return this.http.post(`${environment.apiUrl}/${this.apiController}/autoGeneratedAppDegreeSingle`, { data: data, source: tab });
    } catch (error) {
      this.handleError("addSingleDegree : " + JSON.stringify(error));
    }
  }
  
  bulkDownloadPdf(service,data){
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.apiUrl}/${this.apiController}/bulkDownloadPdf?service=${service}&data=${data}`, { headers: headers, responseType: 'blob'}).map(
    (res) => {
        return new Blob([res], { type: 'application/pdf' });
    });
  }

  getCourseData() {
    try {
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getCourseData`);
    } catch (error) {
      this.handleError("getCourseData : " + JSON.stringify(error));
    }
  }

  addRecord(tab:string): Observable<any> {
    try {
      return this.http.post(`${environment.apiUrl}/${this.apiController}/autoGeneratedAppDegreeSingle`, { tab: tab });
    } catch (error) {
      this.handleError("addSingleDegree : " + JSON.stringify(error));
    }
  }

  checkPinValues(data) {
    try {
      return this.http.post(`${environment.apiUrl}/${this.apiController}/checkPinValues`, { data: data });
    } catch (error) {

    }
  }

  updateAddress(addresDetails, userId, source, appId) {
    return this.http.post(`${environment.apiUrl}/${this.apiController}/updateAddress`, { userId: userId, addresDetails: addresDetails, source: source, appId: appId });
  }

  DegreeCollegeCourse() {
    return this.http.get(`${environment.apiUrl}/${this.apiController}/DegreeCollegeCourse`)
  }
} 

function httpError(error: { (...data: any[]): void; (message?: any, ...optionalParams: any[]): void; }) {
  throw new Error('Function not implemented.');
}
